import { render } from "./ReminderOsBreakdownChart.vue?vue&type=template&id=4b0ca019&scoped=true"
import script from "./ReminderOsBreakdownChart.vue?vue&type=script&lang=js"
export * from "./ReminderOsBreakdownChart.vue?vue&type=script&lang=js"

import "./ReminderOsBreakdownChart.vue?vue&type=style&index=0&id=4b0ca019&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0ca019"]])

export default __exports__